import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Breadcrumbs, Typography } from '@mui/material';
import { FolderOpenOutlined, RightOutlined } from '@ant-design/icons';
import './BreadcrumbsNav.scss';

const DEFAULT_LABELS = {
  projects: 'Projects',
  workato: 'Workato Workspace - Internal Automation/Google Chatbot',
  test2dax: 'Test 2 DAX query t/s with variables : Recipe',
  addJob: 'Add Job',
  addconnection: 'Add Connection',
  editJob:'Edit Job'
};

const BreadcrumbsNav = ({ extra = [], overrides = {} }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);

  const breadcrumbs = pathnames.map((segment, index) => {
    const fullPath = '/' + pathnames.slice(0, index + 1).join('/');

    const override = overrides[fullPath] || {};
    const label = override.label || DEFAULT_LABELS[segment] || segment;
    const path = override.path === false ? null : override.path || fullPath;
    const disabled = override.disabled || false;
    const icon = override.icon || <FolderOpenOutlined />;

    return { label, path, icon, disabled };
  });

  const allBreadcrumbs = [...breadcrumbs, ...extra];

  return (
    <div className="breadcrumb-nav">
      <Breadcrumbs separator={<RightOutlined />} aria-label="breadcrumb">
        {allBreadcrumbs.map((crumb, idx) => {
          const isLast = idx === allBreadcrumbs.length - 1;

          if (crumb.disabled || !crumb.path || isLast) {
            return (
              <Typography key={idx} className="breadcrumb-current">
                {crumb.icon && <span className="breadcrumb-icon">{crumb.icon}</span>}
                {crumb.label}
              </Typography>
            );
          }

          return (
            <Link key={idx} to={crumb.path} className="breadcrumb-link">
              {crumb.icon && <span className="breadcrumb-icon">{crumb.icon}</span>}
              {crumb.label}
            </Link>
          );
        })}
      </Breadcrumbs>
    </div>
  );
};

export default BreadcrumbsNav;
